import { render, staticRenderFns } from "./SubmitMemberAuth.vue?vue&type=template&id=39b9e8bc&scoped=true"
import script from "./SubmitMemberAuth.vue?vue&type=script&lang=js"
export * from "./SubmitMemberAuth.vue?vue&type=script&lang=js"
import style0 from "./SubmitMemberAuth.vue?vue&type=style&index=0&id=39b9e8bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9e8bc",
  null
  
)

export default component.exports